<div class="social-media-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="social-title">
                    <h2>{{ 'PAGE_FOOTER_TEXT.NEVER_COMPROMISE' | transloco }}</h2>
                </div>
                <div class="social-icon-list">
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/Hydratight/" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UCXbd2IGfZW7wrbnPDxp5WaQ" target="_blank"><i class="fa-brands fa-youtube"></i></a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/hydratight/" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
